import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

type ToolbarSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export function ToolbarSearchInput({
  value,
  onChange,
  placeholder = 'Search…',
}: ToolbarSearchInputProps) {
  return (
    <TextField
      variant="standard"
      size="small"
      value={value}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
      sx={{
        minWidth: 220,
        '& .MuiInputBase-root': {
          fontSize: '0.875rem',
        },
        '& .MuiInput-underline:before': {
          borderBottomColor: 'divider',
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
          borderBottomColor: 'text.primary',
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: 'primary.main',
        },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                aria-label="Clear search"
                onClick={() => onChange('')}
                edge="end"
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
      }}
    />
  );
};
